// @flow
import React, { Component } from 'react'
import classnames from 'classnames'
import withClickOutside from 'react-click-outside'

import type { OptionT } from './Option.type'

type PropsT = {
  value: string,
  options: Array<OptionT>,
  onChange: Function,
  onOpen?: Function,
  className?: string,
  placeholder?: string,
  disabled?: boolean
}

function getLabel (value, options) {
  let option = null
  if (options && options.length > 0) {
    option = options.find(option => {
      return option.value === value
    })
  }
  return option && (option.label || option.value)
}

type StateT = {
  showOptions: boolean
}

class Select extends Component<PropsT, StateT> {
  state = {
    showOptions: false
  }

  handleClick = (evt: SyntheticEvent<*>) => {
    if (this.props.disabled) return
    if (!this.state.showOptions && this.props.onOpen) {
      this.props.onOpen()
    }
    this.setState(prevState => ({
      showOptions: !prevState.showOptions
    }))
  }

  handleClickOutside = (evt: SyntheticEvent<*>) => {
    if (this.state.showOptions) {
      this.setState(prevState => ({
        showOptions: false
      }))
    }
  }

  handleClickOption = (option) => {
    const {
      onChange
    } = this.props

    if (option.disabled) return

    if (onChange) onChange(option)
    this.setState(prevState => ({
      showOptions: false
    }))
  }

  render () {
    const {
      className,
      value,
      options,
      placeholder,
      disabled,
      ...rest
    } = this.props

    const otherProps = {
      ...rest
    }

    delete otherProps.onChange
    delete otherProps.onOpen

    const currentValue = getLabel(value, options)

    return (
      <div {...otherProps} className={classnames('Select', className, {
        'Select--open': this.state.showOptions,
        'Select--disabled': disabled
      })}>
        {this.state.showOptions &&
          <ul className='Select__options'>
            {options && options.map(option => (
              <li
                key={option.value}
                className={classnames({
                  'Select__option--disabled': option.disabled,
                  'Select__option--active': option.value === value
                })}
                onClick={(evt: SyntheticEvent<*>) => {
                  this.handleClickOption(option)
                }}
              >
                {option.label || option.value}
              </li>
            ))}
          </ul>
        }
        <div title={currentValue || placeholder} className='Select__value' onClick={this.handleClick}>
          {currentValue
            ? currentValue
            : placeholder
              ? placeholder
              : 'Select a value'
          }
        </div>
        <div className='Select__Arrow'>
          <div className='Arrow Arrow--down' />
        </div>
      </div>
    )
  }
}

export default withClickOutside(Select)
